import { render, staticRenderFns } from "./Dataset.vue?vue&type=template&id=1575452d&scoped=true&"
import script from "./Dataset.vue?vue&type=script&lang=ts&"
export * from "./Dataset.vue?vue&type=script&lang=ts&"
import style0 from "./Dataset.vue?vue&type=style&index=0&id=1575452d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1575452d",
  null
  
)

export default component.exports